<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="6">
        <span class="text-h5 pl-4">Vehicle Availability</span>
      </v-col>
    </v-row>

    <v-row class="ma-0 mt-0 pt-0 ">
      <v-col cols="12" class="pr-0">
        <v-row class="ma-0">
          <v-col class="text-center" cols="12" sm="6" md="3">
            <v-card class="rounded-lg pa-3 hover-effect vehicle-card" outlined
              style="height: 100%; background-color: white; min-height: 140px;">
              <div class="d-flex justify-space-between align-start mb-2">
                <div>
                  <div class="mb-2">
                    <span class="text-body-1 text-dark">Total Vehicles</span>
                  </div>
                  <div>
                    <span class="text-h5 font-weight-bold text-dark">{{ statistics.total_vehicle }}</span>
                  </div>
                </div>
                <div class="icon-container">
                  <v-icon color="white" size="20" class="rounded-lg pa-2" style="background-color: #4285F4">
                    mdi-truck
                  </v-icon>
                </div>
              </div>

              <div class="d-flex align-center mt-auto pt-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" color="info" small outlined class="mr-2">
                      <v-icon left small>mdi-information</v-icon>
                      info
                    </v-chip>
                  </template>
                  <span>{{ "Total No. of Vehicles" || "No details available" }}</span>
                </v-tooltip>

                <!-- <span class="text-caption text-grey">{{ item.statusText }}</span> -->
              </div>

            </v-card>
          </v-col>
          <v-col class="text-center" v-for="(item, index) in cards" :key="index" cols="12" sm="6" md="2">
            <v-card class="rounded-lg pa-3 hover-effect vehicle-card" outlined
              style="height: 100%; background-color: white; min-height: 140px;" @click="item.click && item.click()">
              <div class="d-flex justify-space-between align-start mb-2">
                <div>
                  <div class="mb-2">
                    <span class="text-body-1 text-dark">{{ item.label }}</span>
                  </div>
                  <div>
                    <span class="text-h5 font-weight-bold text-dark">{{ item.value }}</span>
                  </div>
                </div>
                <div class="icon-container">
                  <v-icon :color="item.iconColor" size="20" class="rounded-lg pa-2"
                    :style="`background-color: ${item.iconBgColor}`">
                    {{ item.icon }}
                  </v-icon>
                </div>
              </div>

              <div class="d-flex align-center mt-auto pt-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" :color="item.statusColor" small outlined class="mr-2">
                      <v-icon left small>{{ item.statusIcon }}</v-icon>
                      {{ item.status }}
                    </v-chip>
                  </template>
                  <span>{{ item.tooltipMessage || "No details available" }}</span>
                </v-tooltip>

                <span class="text-caption text-grey">{{ item.statusText }}</span>
              </div>

            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="ma-0 mt-0">
      <v-col cols="12">
        <!-- <div class="mb-3">
          <span class="text-h6 font-weight-bold text-dark pl-4">Assigned Vehicle Status</span>
          <div class="text-caption text-grey pl-4">Breakdown of assigned vehicle statuses</div>
        </div> -->
        <!-- <v-row class="ma-0">
          <v-col class="text-center" v-for="(status, index) in vehicleStatusCards" :key="'status-' + index" cols="12"
            sm="6" lg="4">
            <v-card class="rounded-lg pa-3 hover-effect vehicle-card" outlined style="height: 100%; min-height: 120px;"
              @click="status.click && status.click()">
              <div class="d-flex justify-space-between align-start mb-2">
                <div>
                  <div class="mb-2">
                    <span class="text-body-1 text-dark">{{ status.label }}</span>
                  </div>
                  <div>
                    <span class="text-h5 font-weight-bold text-dark">{{ status.value }}</span>
                  </div>
                </div>
                <div class="icon-container">
                  <v-icon :color="status.iconColor" size="20" class="rounded-lg pa-2"
                    :style="`background-color: ${status.iconBgColor}`">
                    {{ status.icon }}
                  </v-icon>
                </div>
              </div>
              <div class="d-flex align-center mt-auto pt-3">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" small color="blue" class="white--text" label>
                      <v-icon left small>mdi-information</v-icon>
                      Info
                    </v-chip>
                  </template>
                  <span>{{ status.tooltipMessage || "No details available" }}</span>
                </v-tooltip>
              </div>
            </v-card>
          </v-col>
        </v-row> -->

        <!-- Type Wise Availability Section -->
        <v-row class="ma-0 mt-4">
          <v-col cols="12">
            <v-card class="rounded-lg" style="background: #FFA500" outlined>
              <v-card-title class="d-flex justify-space-between align-center pa-4">
                <div>
                  <span class="text-h6 font-weight-bold" style="color: white;">
                    Type Wise Availability
                  </span>
                  <div class="text-caption text-white opacity-80">
                    Vehicle distribution across depot
                  </div>
                </div>
                <div>
                  <!-- <v-btn color="white" outlined small :loading="isDownloading" @click="exportVehicles">
                    <v-icon small>mdi-download</v-icon>
                  </v-btn> -->
                </div>
              </v-card-title>

              <v-card-text class="pa-0">
                <div class="white rounded-b-lg">
                  <!-- Table Header -->
                  <v-row class="ma-0 py-3 px-4 bg-grey-lighten-4 table-header">
                    <v-col v-for="(header, index) in dynamicHeaders" :key="'header-' + index"
                      :cols="getColumnWidth(index, dynamicHeaders.length)" :class="[
                        getHeaderAlignment(header),
                        'font-weight-bold text-body-2',
                        'd-flex align-center'
                      ]" style="min-height: 45x;">
                      <span class="text-truncate">{{ header.title }}</span>
                    </v-col>
                  </v-row>

                  <div v-for="(vehicleType, index) in dynamicTypeWiseData" :key="'type-' + index">
                    <v-row class="ma-0 py-1 px-1 align-center table-row"
                      :class="index % 2 === 0 ? 'white' : 'bg-grey-lighten-5'" style="min-height: 60px;">
                      <!-- Vehicle Type Column -->
                      <v-col :cols="getColumnWidth(0, dynamicHeaders.length)" class="d-flex align-center text-left">
                        <span class="text-body-2 font-weight-bold text-truncate">
                          {{ vehicleType.name }}
                        </span>
                      </v-col>

                      <v-col v-for="(depotKey, depotIndex) in depotKeys" :key="'depot-' + depotIndex"
                        :cols="getColumnWidth(depotIndex + 1, dynamicHeaders.length)"
                        class="text-center d-flex align-center justify-center">
                        <div class="d-flex align-center justify-center column-content">
                          <v-chip :color="getChipColor(vehicleType[depotKey]?.count || 0)" size="small" variant="flat"
                            class="font-weight-bold">
                            {{ vehicleType[depotKey]?.count || 0 }}
                          </v-chip>
                          <v-btn v-if="vehicleType[depotKey]?.count > 0" icon variant="text" class="ml-1 tiny-btn"
                            style="background-color: #FFE5B4;" @click="toggleExpand(vehicleType.name, depotKey)"
                            :aria-label="`Expand ${vehicleType.name} details for depot ${depotKey}`">
                            <v-icon size="14" color="orange"
                              :class="{ 'rotate-180': isExpanded(vehicleType.name, depotKey) }">
                              mdi-chevron-down
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-col>

                      <v-col :cols="getColumnWidth(dynamicHeaders.length - 1, dynamicHeaders.length)"
                        class="text-center d-flex align-center justify-center">
                        <span class="text-h6 font-weight-bold">
                          {{ vehicleType.total_counts }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-divider v-if="index < dynamicTypeWiseData.length - 1" class="my-1"
                      style="border-color: #FFE5B4;" />

                    <div v-for="depotKey in depotKeys" :key="'expanded-' + vehicleType.name + '-' + depotKey">
                      <v-expand-transition>
                        <div
                          v-if="isExpanded(vehicleType.name, depotKey) && vehicleType[depotKey]?.vehicles_data?.length > 0">
                          <div class="pa-4 bg-orange-lighten-5">
                            <div class="mb-3">
                              <span class="text-body-2 font-weight-bold">
                                {{ vehicleType.name }} - {{ getDepotName(depotKey) }}
                              </span>
                              <v-chip color="orange" size="x-small" variant="flat" class="ml-2">
                                {{ vehicleType[depotKey].vehicles_data.length }} vehicles
                              </v-chip>
                            </div>
                            <v-row class="ma-0">
                              <v-col v-for="vehicle in vehicleType[depotKey].vehicles_data.slice(0, 6)"
                                :key="vehicle.vehicle_number" cols="12" sm="6" md="4" class="mb-3">
                                <v-card class="pa-2 border" elevation="0"
                                  style="border: 1px solid #fb8c00; border-radius: 8px;">
                                  <div class="d-flex justify-space-between align-center mb-2">
                                    <span class="text-orange font-weight-bold">
                                      🚛 {{ vehicle.vehicle_number }}
                                    </span>
                                    <v-chip v-if="vehicle.trip_data?.status"
                                      :color="getVehicleStatusColor(vehicle.trip_data.status)" size="x-small"
                                      variant="flat">
                                      {{ vehicle.trip_data.status }}
                                    </v-chip>
                                  </div>
                                  <div v-if="vehicle.driver_name && vehicle.driver_name !== '-'"
                                    class="text-caption text-grey-darken-1 mb-1">
                                    <v-icon size="12" class="mr-1">mdi-account</v-icon>
                                    {{ vehicle.driver_name }}
                                  </div>


                                  <!-- <div class="text-caption text-grey-darken-1 mb-1"
                                    v-if="vehicle.next_availability_date">
                                    <v-icon size="12" class="mr-1">mdi-calendar</v-icon>
                                    Next available: {{ formatDate(vehicle.next_availability_date) }}
                                  </div> -->
                                  <div class="text-caption text-grey-darken-1 mb-1"
                                    v-if="vehicle.available_days_count !== '-'">
                                    <v-icon size="12" class="mr-1">mdi-clock</v-icon>
                                    Available since {{ vehicle.available_days_count }} days
                                  </div>
                                  <div class="text-caption text-grey-darken-1" v-if="vehicle.emp_id !== '-'">
                                    <v-icon size="12" class="mr-1">mdi-tag</v-icon>
                                    ID: {{ vehicle.emp_id }}
                                  </div>
                                  <div class="text-caption text-grey-darken-1" v-if="vehicle.trip_data?.trip_number">
                                    <v-icon size="12" class="mr-1">mdi-map</v-icon>
                                    Trip: {{ vehicle.trip_data.trip_number }}
                                  </div>
                                </v-card>
                              </v-col>
                            </v-row>
                            <div class="text-center mt-3" v-if="vehicleType[depotKey].vehicles_data.length > 6">
                              <v-btn color="orange" class="px-4"
                                @click="openAllDataDialog(vehicleType[depotKey].vehicles_data)">
                                <v-icon class="mr-2">mdi-eye</v-icon>
                                View all {{ vehicleType[depotKey].vehicles_data.length }} vehicles
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </v-expand-transition>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Next Availability Section  -->
        <v-row class="ma-0 mt-4">
          <v-col cols="12">
            <v-card class="rounded-lg" style="border: 1px solid #E3F2FD;" outlined>
              <v-card-title class="d-flex justify-space-between align-center pa-4"
                style="background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);">
                <div>
                  <span class="text-h6 font-weight-bold text-white">Next Availability</span>
                  <div class="text-caption text-white opacity-90">
                    Upcoming vehicle availability schedule by date
                  </div>
                </div>
                <div>
                  <!-- <v-btn color="white" outlined small :loading="isDownloading" @click="exportNextAvailability">
                    <v-icon small>mdi-download</v-icon>
                  </v-btn> -->
                </div>
              </v-card-title>

              <v-card-text class="pa-0">
                <div class="white rounded-b-lg">

                  <v-row class="ma-0 py-1 px-1 bg-grey-lighten-4 table-header">
                    <v-col v-for="(header, index) in nextAvailabilityHeaders" :key="'next-header-' + index"
                      :cols="getColumnWidth(index, nextAvailabilityHeaders.length)" :class="[
                        getHeaderAlignment(header),
                        'font-weight-bold text-body-2',
                        'd-flex align-center'
                      ]" style="min-height: 48px;">
                      <span class="text-truncate">{{ header.title }}</span>
                    </v-col>
                  </v-row>

                  <div v-for="(dateEntry, index) in nextAvailabilityData" :key="'next-date-' + index">
                    <v-row class="ma-0 py-3 px-4 align-center table-row"
                      :class="index % 2 === 0 ? 'white' : 'bg-grey-lighten-5'" style="min-height: 60px;">

                      <v-col :cols="getColumnWidth(0, nextAvailabilityHeaders.length)"
                        class="d-flex align-center text-left">
                        <div class="d-flex align-center">
                          <v-icon color="primary" size="16" class="mr-2">mdi-calendar</v-icon>
                          <span class="text-body-2 font-weight-bold text-truncate">
                            {{ dateEntry.name }}
                          </span>
                        </div>
                      </v-col>

                      <v-col v-for="(depotKey, depotIndex) in nextDepotKeys" :key="'next-depot-' + depotIndex"
                        :cols="getColumnWidth(depotIndex + 1, nextAvailabilityHeaders.length)"
                        class="text-center d-flex align-center justify-center">
                        <div class="d-flex align-center justify-center column-content">
                          <v-chip :color="getNextAvailabilityChipColor(dateEntry[depotKey]?.count || 0)" size="small"
                            variant="flat" class="font-weight-bold">
                            {{ dateEntry[depotKey]?.count || 0 }}
                          </v-chip>
                          <v-btn v-if="(dateEntry[depotKey]?.count || 0) > 0" icon variant="text" class="ml-1 tiny-btn"
                            style="background-color: #E3F2FD;" @click="toggleExpand(dateEntry.name, depotKey, 'next')"
                            :aria-label="`Expand availability for ${dateEntry.name} at ${getNextDepotName(depotKey)}`">
                            <v-icon size="14" color="primary"
                              :class="{ 'rotate-180': isExpanded(dateEntry.name, depotKey, 'next') }">
                              mdi-chevron-down
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-col>

                      <v-col :cols="getColumnWidth(nextAvailabilityHeaders.length - 1, nextAvailabilityHeaders.length)"
                        class="text-center d-flex align-center justify-center">
                        <span class="text-h6 font-weight-bold">
                          {{ dateEntry.total_counts || calculateDateTotal(dateEntry) }}
                        </span>
                      </v-col>
                    </v-row>

                    <v-divider v-if="index < nextAvailabilityData.length - 1" class="my-1"
                      style="border-color: #E3F2FD;" />

                    <div v-for="depotKey in nextDepotKeys" :key="'next-expanded-' + dateEntry.name + '-' + depotKey">
                      <v-expand-transition>
                        <div
                          v-if="isExpanded(dateEntry.name, depotKey, 'next') && dateEntry[depotKey]?.vehicles_data?.length > 0">
                          <div class="pa-4 bg-blue-lighten-5">
                            <div class="mb-3">
                              <span class="text-body-2 font-weight-bold">
                                Available on {{ dateEntry.name }} - {{ getNextDepotName(depotKey) }}
                              </span>
                              <v-chip color="primary" size="x-small" variant="flat" class="ml-2">
                                {{ dateEntry[depotKey].vehicles_data.length }} vehicles
                              </v-chip>
                            </div>
                            <v-row class="ma-0">
                              <v-col v-for="vehicle in dateEntry[depotKey].vehicles_data.slice(0, 6)"
                                :key="'next-' + vehicle.vehicle_number" cols="12" sm="6" md="4" class="mb-3">
                                <v-card class="pa-2 border" elevation="0"
                                  style="border: 1px solid #2196F3; border-radius: 8px;">
                                  <div class="d-flex justify-space-between align-center mb-2">
                                    <span class="text-primary font-weight-bold">
                                      🚛 {{ vehicle.vehicle_number }}
                                    </span>
                                    <v-chip v-if="vehicle.trip_data?.status"
                                      :color="getVehicleStatusColor(vehicle.trip_data.status)" size="x-small"
                                      variant="flat">
                                      {{ vehicle.trip_data.status }}
                                    </v-chip>

                                  </div>
                                  <div v-if="vehicle.driver_name && vehicle.driver_name !== '-'"
                                    class="text-caption text-grey-darken-1 mb-1">
                                    <v-icon size="12" class="mr-1">mdi-account</v-icon>
                                    {{ vehicle.driver_name }}
                                  </div>



                                  <div class="text-caption text-grey-darken-1 mb-1">
                                    <v-icon size="12" class="mr-1">mdi-car</v-icon>
                                    Type: {{ vehicle.vehicle_type || 'N/A' }}
                                  </div>
                                  <div class="text-caption text-grey-darken-1 mb-1">
                                    <v-icon size="12" class="mr-1">mdi-car</v-icon>
                                    Trip: {{ vehicle.trip || 'N/A' }}
                                  </div>
                                  <div class="text-caption text-grey-darken-1 mb-1"
                                    v-if="vehicle.next_availability_date">
                                    <v-icon size="12" class="mr-1">mdi-calendar</v-icon>
                                    Next available: {{ formatDate(vehicle.next_availability_date) }}
                                  </div>
                                  <div class="text-caption text-grey-darken-1 mb-1"
                                    v-if="vehicle.available_days_count !== '-'">
                                    <v-icon size="12" class="mr-1">mdi-clock</v-icon>
                                    Available since {{ vehicle.available_days_count }} days
                                  </div>
                                  <div class="text-caption text-grey-darken-1" v-if="vehicle.emp_id !== '-'">
                                    <v-icon size="12" class="mr-1">mdi-tag</v-icon>
                                    ID: {{ vehicle.emp_id }}
                                  </div>
                                  <div class="text-caption text-grey-darken-1"
                                    v-if="vehicle.current_depot_name && vehicle.current_depot_name !== '-'">
                                    <v-icon size="12" class="mr-1">mdi-map-marker</v-icon>
                                    Current Depot: {{ vehicle.current_depot_name }}
                                  </div>
                                </v-card>
                              </v-col>
                            </v-row>
                            <div class="text-center mt-3" v-if="dateEntry[depotKey].vehicles_data.length > 6">
                              <v-btn color="primary" class="px-4"
                                @click="openAllDataDialog(dateEntry[depotKey].vehicles_data)">
                                <v-icon class="mr-2">mdi-eye</v-icon>
                                View all {{ dateEntry[depotKey].vehicles_data.length }} vehicles
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </v-expand-transition>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <VehicleDataListDialog v-model="showAllVehicleDialog" :vehicleList="vehicleList" />
  </div>
</template>

<script>
import VehicleDataListDialog from "@/components/ModuleBased/dialogForms/VehicleDataListDialog.vue";

export default {
  name: 'VehicleAvailabilityDashboard',

  components: {
    VehicleDataListDialog,
  },

  data() {
    return {
      showAllVehicleDialog: false,
      isExporting: false,
      isDownloading: false,

      dynamicHeaders: [],
      dynamicTypeWiseData: [],
      depotKeys: [],

      nextAvailabilityHeaders: [],
      nextAvailabilityData: [],
      nextDepotKeys: [],

      statistics: {},

      vehicleList: [],
      expandedSections: {},

      expanded: [],
      expanded2: [],
      cellCalled: [],
      nextAvailabilityCellCalled: [],
      tripWiseAvailabilityHeader: [],
      tripWiseAvailabilityRows: [],
      headers_x: [],
      nextAvailabilityChartData: {},
      nextAvailabilityHeader: [],
      nextAvailabilityRows: [],
      isNextAvailabilityChartData: false
    }
  },

  computed: {
    vehicleStatusCards() {
      return [
        {
          label: "On Trip",
          value: this.statistics.engaged_vehicle,
          icon: "mdi-map-marker-path",
          iconColor: "white",
          iconBgColor: "#a855f7",
          status: "Active",
          statusIcon: "mdi-information",
          statusColor: "info",
          tooltipMessage: "Vehicle is On Trip Stage",
          click: () => this.handleCardClick('on_trip')
        },
        {
          label: "Idle",
          value: this.statistics.available,
          icon: "mdi-pause-circle",
          iconColor: "white",
          iconBgColor: "#10b981",
          status: "Active",
          statusIcon: "mdi-information",
          statusColor: "info",
          tooltipMessage: "Vehicle is in Idle Stage",
          click: () => this.handleCardClick('idle')
        },
        {
          label: "Inactive",
          value: this.statistics.in_active,
          icon: "mdi-close-circle",
          iconColor: "white",
          iconBgColor: "#6b7280",
          status: "Info",
          statusIcon: "mdi-information",
          statusColor: "info",
          tooltipMessage: "Vehicle is inactive Stage",
          click: () => this.handleCardClick('inactive')
        }
      ]
    },

    cards() {
      return [
        // {
        //   label: "Total Vehicles",
        //   value: this.statistics.total_vehicle,
        //   icon: "mdi-truck",
        //   iconColor: "white",
        //   iconBgColor: "#4285F4",
        //   status: "info",
        //   statusIcon: "mdi-information",
        //   statusColor: "info",
        //   tooltipMessage: "Total No. of Vehicles",
        //   click: () => this.handleCardClick('total_vehicles')
        // },
        // {
        //   label: "Assigned",
        //   value: this.statistics.assigned_total_vehicle,
        //   icon: "mdi-check-circle",
        //   iconColor: "white",
        //   iconBgColor: "#34A853",
        //   status: "info",
        //   statusIcon: "mdi-check-circle",
        //   statusColor: "success",
        //   tooltipMessage: "Vehicle is Assigned Stage",
        //   click: () => this.handleCardClick('assigned')
        // },
        // {
        //  label: "Un Assigned",
        //  value: this.statistics.unassigned_total_vehicle,
        //  icon: "mdi-close-circle",
        //  iconColor: "white",
        //  iconBgColor: "#EA4335",
        //  status: "info",
        //  statusIcon: "mdi-clock",
        //  statusColor: "warning",
        //  tooltipMessage: "Vehicle is Un Assigned Stage",
        //  click: () => this.handleCardClick('unassigned')
        //},
        {
          label: "In Maintenance",
          value: this.statistics.in_maintenance,
          icon: "mdi-wrench-outline",
          iconColor: "white",
          iconBgColor: "#FBBC04",
          status: "info",
          statusIcon: "mdi-refresh",
          statusColor: "info",
          tooltipMessage: "Vehicle is in maintenance",
          click: () => this.handleCardClick('maintenance')
        },
        {
          label: "On Trip",
          value: this.statistics.engaged_vehicle,
          icon: "mdi-map-marker-path",
          iconColor: "white",
          iconBgColor: "#a855f7",
          status: "Active",
          statusIcon: "mdi-information",
          statusColor: "info",
          tooltipMessage: "Vehicle is on Trip",
          click: () => this.handleCardClick('on_trip')
        },
        {
          label: "Idle",
          value: this.statistics.available,
          icon: "mdi-pause-circle",
          iconColor: "white",
          iconBgColor: "#10b981",
          status: "Active",
          statusIcon: "mdi-information",
          statusColor: "info",
          tooltipMessage: "Vehicle is available",
          click: () => this.handleCardClick('idle')
        },
        {
          label: "Inactive",
          value: this.statistics.in_active,
          icon: "mdi-close-circle",
          iconColor: "white",
          iconBgColor: "#6b7280",
          status: "Info",
          statusIcon: "mdi-information",
          statusColor: "info",
          tooltipMessage: "Vehicle is inactive Stage",
          click: () => this.handleCardClick('inactive')
        }
      ]
    },
  },

  methods: {
    handleCardClick(cardType) {
      this.$router.push("/app/admin/asset-management/vehicle/list");
    },

    openAllDataDialog(vehicleData = this.vehicleList) {
      this.vehicleList = vehicleData;
      this.showAllVehicleDialog = true;
    },

    toggleExpand(identifier, branch, section = 'main') {
      const key = `${identifier}_${branch}${section !== 'main' ? '_' + section : ''}`;
      this.$set(this.expandedSections, key, !this.expandedSections[key]);
    },

    isExpanded(identifier, branch, section = 'main') {
      const key = `${identifier}_${branch}${section !== 'main' ? '_' + section : ''}`;
      return !!this.expandedSections[key];
    },

    formatDate(dateString) {
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return dateString;
      }
    },

    getColumnWidth(index, totalColumns) {
      if (index === 0) return 3;
      if (index === totalColumns - 1) return 2;

      const remainingCols = 12 - 3 - 2;
      const depotCount = totalColumns - 2;

      if (depotCount > 0) {
        return Math.floor(remainingCols / depotCount);
      }
      return 2;
    },

    getHeaderAlignment(header) {
      if (header.align === 'center' || (header.key && header.key !== 'name' && !header.title.toLowerCase().includes('date') && !header.title.toLowerCase().includes('depot'))) {
        return 'text-center';
      }
      return 'text-left';
    },

    getChipColor(count) {
      if (count === 0) return 'grey';
      if (count <= 5) return 'warning';
      if (count <= 15) return 'info';
      return 'success';
    },

    getNextAvailabilityChipColor(count) {
      if (count === 0) return 'grey';
      if (count <= 3) return 'success';
      if (count <= 8) return 'info';
      return 'primary';
    },

    getVehicleStatusColor(status) {
      const statusColors = {
        'Available': 'success',
        'Assigned': 'warning',
        'On Trip': 'info',
        'Maintenance': 'error',
        'Inactive': 'grey'
      };
      return statusColors[status] || 'primary';
    },

    getDepotName(depotKey) {
      const depotId = depotKey.replace('depot_', '');
      const header = this.dynamicHeaders.find(h => h.key == depotId);
      return header ? header.title.split(' (')[0] : `Depot ${depotId}`;
    },

    getNextDepotName(depotKey) {
      const depotId = depotKey.replace('depot_', '');
      const header = this.nextAvailabilityHeaders.find(h => h.key == depotId);
      return header ? header.title.split(' (')[0] : `Depot ${depotId}`;
    },

    calculateTotal(vehicleType) {
      let total = 0;
      this.nextDepotKeys.forEach(depotKey => {
        total += vehicleType[depotKey]?.count || vehicleType[depotKey] || 0;
      });
      return total;
    },

    calculateDateTotal(dateEntry) {
      let total = 0;
      this.nextDepotKeys.forEach(depotKey => {
        total += dateEntry[depotKey]?.count || 0;
      });
      return total;
    },

    processApiData(apiResponse) {
      if (!apiResponse?.table_data) return;

      const { headers, row_data } = apiResponse.table_data;

      this.dynamicHeaders = headers;

      this.depotKeys = headers
        .slice(1, -1)
        .map(header => `depot_${header.key}`);

      this.dynamicTypeWiseData = row_data;

      this.tripWiseAvailabilityHeader = headers;
      this.tripWiseAvailabilityRows = row_data;
    },

    processNextAvailabilityData(apiResponse) {
      if (!apiResponse?.table_data) return;

      const { headers, row_data } = apiResponse.table_data;

      this.nextAvailabilityHeaders = headers;

      this.nextDepotKeys = headers
        .slice(1, -1)
        .map(header => `depot_${header.key}`);

      this.nextAvailabilityData = row_data;

      this.nextAvailabilityHeader = headers;
      this.nextAvailabilityRows = row_data;
    },

    getStatistics(params) {
      this.$bus.$emit("showLoader", true);
      this.$api.assetsAvailabilityDashboard
        .getAssetsAvailabilityStats(params)
        .then(async (res) => {
          this.statistics = res.data;
        })
        .catch((err) => {
          this.handleApiError(err, "Fetch Statistics Failed");
        });
      this.$bus.$emit("showLoader", false);
    },

    getTripWiseAvailabilityChart(params) {

      this.$bus.$emit("showLoader", true);
      this.isTypeWiseAvailabilityChartData = false;
      this.$api.assetsAvailabilityDashboard
        .getTypeWiseVehicleAvailabilityChart(params)
        .then(async (res) => {
          this.processApiData(res.data);
          this.typeWiseAvailabilityChartData = res.data?.charts_data;
          this.isTypeWiseAvailabilityChartData = true;
        })
        .catch((err) => {
          this.handleApiError(err, "Fetch Chart Data Failed");
        });
      this.$bus.$emit("showLoader", false);
    },

    getNextAvailabilityChart(params) {
      this.$bus.$emit("showLoader", true);
      if (this.vehicle_type) {
        params = {
          vehicle_type: this.vehicle_type,
          ...params,
        };
      }
      this.isNextAvailabilityChartData = false;
      this.$api.assetsAvailabilityDashboard
        .getNextVehicleAvailabilityChart(params)
        .then(async (res) => {
          this.processNextAvailabilityData(res.data);
          this.nextAvailabilityChartData = res.data?.charts_data;
          this.isNextAvailabilityChartData = true;
        })
        .catch((err) => {
          this.handleApiError(err, "Fetch Next Availability Data Failed");
        });
      this.$bus.$emit("showLoader", false);
    },

    exportVehicles() {
      console.log('Exporting type-wise vehicles...');
    },

    exportNextAvailability() {
      console.log('Exporting next availability data...');
    },

    handleApiError(err, defaultMessage) {
      this.formErrors = err.data?.error;
      if (err && err.data) {
        const showToast = (message) => {
          this.$bus.$emit("showToastMessage", {
            message,
            color: "error",
            hasActions: true,
          });
        };

        if (err.data.message) {
          showToast(err.data.message);
        } else if (
          err.data.error?.non_field_errors?.length
        ) {
          showToast(err.data.error.non_field_errors.join(", "));
        } else {
          showToast(defaultMessage);
        }
      }
    },
  },

  beforeMount() {
    this.getStatistics();
    this.getTripWiseAvailabilityChart();
    this.getNextAvailabilityChart();
  },
}
</script>

<style scoped>
.border-bottom-dotted {
  border-bottom: 1px dashed #aaaa;
  height: 0;
}

.hover-effect {
  transition: all 0.3s ease-in-out;
}

.hover-effect:hover {
  transform: translateY(-4px);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
}

.vehicle-card {
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e9ecef;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.vehicle-card:hover {
  border-color: #dee2e6;
}

.icon-container {
  border-radius: 12px;
}

.text-dark {
  color: #2c3e50 !important;
}

.text-grey {
  color: #6c757d !important;
}

.tiny-btn {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  min-height: 20px !important;
  padding: 0 !important;
}

.rotate-180 {
  transform: rotate(180deg);
}

.table-header .v-col,
.table-row .v-col {
  display: flex;
  align-items: center;
  padding-left: 6px !important;
  padding-right: 6px !important;
  box-sizing: border-box;
}

.table-header .v-col {
  min-height: 20px;
  font-weight: 600 !important;
  background-color: #f5f5f5;
}

.table-row .v-col {
  min-height: 50px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.text-center {
  justify-content: center !important;
}

.text-left {
  justify-content: flex-start !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.column-content {
  width: 100%;
  gap: 4px;
}

.d-flex.align-center.justify-center {
  gap: 4px;
  width: 100%;
}

.table-row {
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.05);
}

.table-row:last-child {
  border-bottom: none;
}

.bg-blue-lighten-5 {
  background-color: #e3f2fd !important;
  border-top: 1px solid rgba(33, 150, 243, 0.1);
}

.bg-orange-lighten-5 {
  background-color: #fff3e0 !important;
  border-top: 1px solid rgba(255, 165, 0, 0.1);
}

.border {
  border-width: 1px !important;
  border-style: solid !important;
}

@media (max-width: 768px) {
  .text-h5 {
    font-size: 1.25rem !important;
  }

  .text-h6 {
    font-size: 1.125rem !important;
  }

  .vehicle-card {
    min-height: 120px !important;
  }

  .pa-4 {
    padding: 12px !important;
  }

  .v-col[class*="cols-"] {
    flex: 1 1 auto;
    min-width: 0;
  }

  .table-header .v-col,
  .table-row .v-col {
    font-size: 0.875rem;
    padding-left: 4px !important;
    padding-right: 4px !important;
  }

  .text-h6 {
    font-size: 1rem !important;
  }

  .column-content {
    flex-direction: column;
    align-items: center;
  }
}

.v-expand-transition-enter-active,
.v-expand-transition-leave-active {
  transition: all 0.3s ease-in-out;
}

.v-btn:focus {
  outline: 2px solid #2196F3;
  outline-offset: 2px;
}

.v-chip--size-x-small {
  font-weight: 600;
}

.v-chip--size-small {
  font-weight: 600;
}

.mdi-chevron-down {
  transition: transform 0.3s ease;
}

.v-divider {
  opacity: 0.8;
}

.table-header,
.table-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.table-header .v-col,
.table-row .v-col {
  padding-top: 4px !important;
  padding-bottom: 3px !important;
}

.v-card {
  display: flex;
  flex-direction: column;
}

.v-card-text {
  flex: 1;
}

.column-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
}

.rounded-b-lg {
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}
</style>